<template>
    <div style="height: 100vh;-ms-overflow-y: scroll;overflow-y: scroll">
        <ul class="gongneng" >
            <li><h1>编辑新闻</h1></li>
            <li>
                <el-button type="success" @click="this.$router.back()">新闻列表</el-button>
            </li>
        </ul>
        <div>



            <el-form ref="form" :model="form" >
                <el-form-item label="新闻标题">
                    <el-input v-model="form.ch.title"></el-input>


                    <div class="otherLanguage" style="margin-top: 5px">
                        <el-input  style="width: 33%" v-model="form.en.title" placeholder="新闻标题(英文)"></el-input>
                        <el-input  style="width: 33%" v-model="form.cht.title" placeholder="新闻标题(繁体)"></el-input>
                        <el-input  style="width: 33%" v-model="form.de.title" placeholder="新闻标题(德文)"></el-input>
                    </div>

                </el-form-item>
                <el-form-item label="新闻类型">
                    <el-select v-model="form.category" placeholder="请选择">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                </el-form-item>

<!--                产品描述-->
                <el-form-item label="产品描述">
                    <div>
                        <el-radio-group v-model="radio1" >
                            <el-radio-button label="中文简体"></el-radio-button>
                            <el-radio-button label="中文繁体"></el-radio-button>
                            <el-radio-button label="英文"></el-radio-button>
                            <el-radio-button label="德文"></el-radio-button>
                        </el-radio-group>
                    </div>
                    <div style="border: 1px solid #ccc">
                        <Toolbar
                                style="border-bottom: 1px solid #ccc"
                                :editor="editorRef"
                                :defaultConfig="toolbarConfig"
                                :mode="mode"
                        />
                        <Editor
                                style="height: 500px; overflow-y: hidden;"
                                v-model="valueHtml"
                                :defaultConfig="editorConfig"
                                :mode="mode"
                                @onCreated="handleCreated"
                        />

                    </div>

                </el-form-item>
<!--                缩略图-->
                <el-form-item label="缩略图">
                    <el-upload
                            class="upload-demo"
                            :action="imgUrl"
                            :on-change="handleChange"
                            :on-success="handleAvatarSuccess2"
                            :on-remove="handleChange"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                </el-form-item>

<!--                添加日期-->
                <el-form-item label="添加日期">
                    <el-input v-model="form.ch.addTime"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    <el-button @click="this.$router.back()">返回</el-button>
                </el-form-item>
            </el-form>

        </div>

        <div>
            <el-dialog
                    title="提示"
                    v-model="dialogVisible"
                    width="70%"
                    :before-close="handleClose">
                <div style="border: 1px solid #ccc">
                    <Toolbar
                            style="border-bottom: 1px solid #ccc"
                            :editor="editorRef"
                            :defaultConfig="toolbarConfig"
                            :mode="mode"
                    />
                    <Editor
                            style="height: 500px; overflow-y: hidden;"
                            v-model="valueHtml"
                            :defaultConfig="editorConfig"
                            :mode="mode"
                            @onCreated="handleCreated"
                    />

                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
                </span>
            </el-dialog>

        </div>

    </div>
</template>
<script>
    import '@wangeditor/editor/dist/css/style.css' // 引入 css

    import {onBeforeUnmount, ref, shallowRef, onMounted, getCurrentInstance} from 'vue'
    import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import request from "@/utils/request";


    export default {
        components: { Editor, Toolbar },
        data(){
            return{
                radio1: '中文简体',
                options:[{lable:1,value:"公司新闻"},{lable:2,value:"行业新闻"}],
                dialogVisible:false,
                form: {
                        ch:{},cht:{},en:{},de:{}
                },
                editorRef:null,
                valueHtml:"<p>模拟 Ajax 异步设置内容</p>",
                mode: 'default', // 或 'simple'
                toolbarConfig:null,
                editorConfig:null,
                handleCreated:null,


            //    图片
                fileList: [],
                imgUrl:""
            }
        },
        methods:{
            onSubmit() {
                if (this.radio1=="中文简体"){
                    this.form.ch.content=this.valueHtml
                }else if(this.radio1=="中文繁体"){
                    this.form.cht.content=this.valueHtml
                }else if(this.radio1=="英文"){
                    this.form.en.content=this.valueHtml
                }else {
                    this.form.de.content=this.valueHtml

                }


                this.$refs['form'].validate((valid) => {
                    if (valid){

                        request.post("/news_management/companyNewsSave",this.form).then(res => {

                            if (res.code==200){
                                this.$message({
                                    type: 'success',
                                    message: res.data
                                });
                            }else {
                                this.$message({
                                    type: 'warning',
                                    message: res.data
                                });
                            }


                        })
                    }else{
                    }

                })

            },
            handleChange(file, fileList) {

                this.fileList = fileList.slice(-3);
            },

            handlePreview(file) {
            },
            handleAvatarSuccess(res) {
                //res就是文件路径
                this.form.image = res;
            },
            handleAvatarSuccess2(res) {
                //res就是文件路径
                this.form.ch.image = res;
                this.form.en.image = res;
                this.form.cht.image = res;
                this.form.de.image = res;
                this.fileList.url=res
            },



        },
        beforeMount() {
            
            this.editorRef=shallowRef()
            this.valueHtml = ref('')
            this.toolbarConfig = {}
            this.editorConfig = { placeholder: '请输入内容...',
                MENU_CONF: {
                    // 图片上传
                    uploadImage: {
                        server: '/api/BackStage/productCategory/upload',
                        fieldName: 'file',
                        // 单个文件的最大体积限制，默认为 2M
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        // 最多可上传几个文件，默认为 100
                        maxNumberOfFiles: 10,
                        // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
                        allowedFileTypes: ['image/*'],
                        // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
                        meta: {
                            // token: 'xxx',
                            // otherKey: 'yyy'
                            // file:''
                        },
                        // 将 meta 拼接到 url 参数中，默认 false
                        metaWithUrl: false,

                        // 自定义增加 http  header
                        headers: {

                            'Access-Control-Allow-Origin': 'origin'
                            // Accept: 'text/x-json',
                            // otherKey: 'xxx'
                        },

                        // 跨域是否传递 cookie ，默认为 false
                        withCredentials: true,

                        // 超时时间，默认为 10 秒
                        timeout: 10 * 1000, //10 秒

                        // 上传前
                        onBeforeUpload(files) {
                            // Message({
                            //     message: '图片正在上传中,请耐心等待',
                            //     duration: 0,
                            //     customClass: 'uploadTip',
                            //     iconClass: 'el-icon-loading',
                            //     showClose: true
                            // });
                            return files;
                        },
                        // 自定义插入图片
                        customInsert(res, insertFn) {
                            // 因为自定义插入导致onSuccess与onFailed回调函数不起作用,自己手动处理
                            // 先关闭等待的Message
                            // Message.closeAll();
                            if (res.code === 200) {
                                // Message.success({
                                //     message: `${res.data.originalName} 上传成功`
                                // });
                            } else {
                                // Message.error({
                                //     message: `${res.data.originalName} 上传失败，请重新尝试`
                                // });
                            }

                            insertFn(res.data.link, res.data.name, res.data.link);
                        },

                        // 单个文件上传成功之后
                        onSuccess(file, res) {
                            // console.log(`${file.name} 上传成功`, res);

                        },

                        // 单个文件上传失败
                        onFailed(file, res) {
                            console.log(`${file.name} 上传失败`, res);
                        },

                        // 上传进度的回调函数
                        onProgress(progress) {
                            console.log('progress', progress);
                            // progress 是 0-100 的数字
                        },

                        // 上传错误，或者触发 timeout 超时
                        onError(file, err, res) {
                            console.log(`${file.name} 上传出错`, err, res);
                        }
                    },

                }}
            this.handleCreated = (editor) => {
                this.editorRef = editor // 记录 editor 实例，重要！
            }
        },
        mounted(){
            const internalInstance  = getCurrentInstance(); //  方式二，此方法在开发环境以及生产环境下都能放到组件上下文对象（推荐）
            const globalProperties = internalInstance.appContext.config.globalProperties
            const imgUrl= globalProperties.$imgUrl




            this.imgUrl=imgUrl
            if (this.$route.query.id!=undefined){

                this.form.id=this.$route.query.id
                let title=this.$route.query.title
                this.form.category=title
                    request.get("/news_management/2/"+this.form.id+"/"+title).then(res => {
                        for (let i = 0; i <res.data.length ; i++) {
                            if (res.data[i].language=="zh"){
                                this.form.ch=res.data[i]
                                this.valueHtml=res.data[i].content
                            }else if(res.data[i].language=="cht"){
                                this.form.cht=res.data[i]
                            }else if(res.data[i].language=="en"){
                                this.form.en=res.data[i]
                            }else{
                                this.form.de=res.data[i]
                            }
                        }


                    })


            }





        },
        beforeUnmount() {

                const editor = this.editorRef
                if (editor == null) return
                editor.destroy()

        },
        watch:{

            radio1(news,old){
               let htmls=this.valueHtml

                if (old != news){
                    // this.$confirm('检测到未保存的内容，是否在离开页面前保存修改？', '确认信息', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     this.$message({
                    //         type: 'success',
                    //         message: '保存成功!'
                    //     });

                        if (old=="中文简体"){
                            this.form.ch.content=htmls
                        }else if(old=="中文繁体"){
                            this.form.cht.content=htmls
                        }else if(old=="英文"){
                            this.form.en.content=htmls
                        }else {
                            this.form.de.content=htmls

                        }

                        if (news=="中文简体"){
                            this.valueHtml= this.form.ch.content
                        }else if(news=="中文繁体"){
                            this.valueHtml=this.form.cht.content
                        }else if(news=="英文"){
                            this.valueHtml=this.form.en.content
                        }else {
                            this.valueHtml=this.form.de.content

                        }
                    // }).catch(() => {
                    //     this.$message({
                    //         type: 'info',
                    //         message: '已取消保存'
                    //     });
                    // });
                }

            }
        }

    }
</script>
<style scoped lang="less">
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
    li:first-child{
        float: left;
        margin-left: 10px;
    }
    li:last-child{
        float: right;
        margin-right: 10px;
    }
    }
    .el-form{
        padding-top: 10px;
        .el-input{width: 40vw}
    }
     .avatar-uploader-icon {
         border: 1px dashed #d9d9d9;
         border-radius: 6px;
         cursor: pointer;
         position: relative;
         overflow: hidden;
         font-size: 28px;
         color: #8c939d;
         width: 250px;
         height: 150px;
         line-height: 150px;
         text-align: center;
     }
    .avatar-uploader-icon:hover {
        border-color: #409eff;
    }
    .avatar {
        width: 250px;
        height: 150px;
        display: block;
    }

</style>